<template>
  <div>
    <b-navbar toggleable="lg" type="dark" class="nav-bar">
      <b-navbar-brand v-b-toggle.sidebar-backdrop
        ><b-link to="/home">
          <img
            src="@/assets/image/icons/menu.png"
            rounded
            alt="Rounded image"
            width="30"
            height="30"
          />
        </b-link>
      </b-navbar-brand>

      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

      <b-collapse id="nav-collapse" is-nav>
        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <!-- Using 'button-content' slot -->
            <template v-slot:button-content>
              <em>Bem vindo(a) {{ email }}</em>
            </template>
            <b-dropdown-item @click="logout()">Sair</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      email: "",
    };
  },
  created() {
    this.email = localStorage.getItem("email");
  },
  methods: {
    logout() {
      localStorage.removeItem("token");
      localStorage.removeItem("email");
      localStorage.removeItem("user");
      localStorage.removeItem("nivel");

      this.$router.push("login");
    },
    Open(id) {
      switch (id) {
        case 1:
          if (this.$route.name != "Home") this.$router.push("home");
          break;
        case 2:
          if (this.$route.name != "Entradas") this.$router.push("entradas");
          break;
        case 3:
          if (this.$route.name != "Estoque") this.$router.push("estoque");
          break;
        case 4:
          if (this.$route.name != "SaidaCadastro")
            this.$router.push("saidas-cadastro");
          break;
        case 5:
          if (this.$route.name != "SaidasLista")
            this.$router.push("saidas-lista");
          break;
        case 6:
          if (this.$route.name != "ServicosCadastro")
            this.$router.push("servicos-cadastro");
          break;
        case 7:
          if (this.$route.name != "ServicosLista")
            this.$router.push("servicos-lista");
          break;
        case 8:
          if (this.$route.name != "ClienteCadastro")
            this.$router.push("clientes-cadastro");
          break;
        case 9:
          if (this.$route.name != "ClientesLista")
            this.$router.push("clientes-lista");
          break;
        case 10:
          if (this.$route.name != "RelatoriosEstoque")
            this.$router.push("relatorios-estoque");
          break;
        case 11:
          if (this.$route.name != "RelatoriosVendas")
            this.$router.push("relatorios-vendas");
          break;
        case 12:
          if (this.$route.name != "RelatoriosClientes")
            this.$router.push("relatorios-clientes");
          break;
        case 13:
          if (this.$route.name != "UsuariosCadastro")
            this.$router.push("usuarios-cadastro");
          break;
        case 14:
          if (this.$route.name != "UsuariosLista")
            this.$router.push("usuarios-lista");
          break;
        case 15:
          if (this.$route.name != "BasesCadastro")
            this.$router.push("bases-cadastro");
          break;
        case 16:
          if (this.$route.name != "BasesLista")
            this.$router.push("bases-lista");
          break;
        case 17:
          if (this.$route.name != "AdicoesCadastro")
            this.$router.push("adicoes-cadastro");
          break;
        case 18:
          if (this.$route.name != "AdicoesLista")
            this.$router.push("adicoes-lista");
          break;
        case 19:
          if (this.$route.name != "ArmacoesCadastro")
            this.$router.push("armacoes-cadastro");
          break;
        case 20:
          if (this.$route.name != "ArmacoesLista")
            this.$router.push("armacoes-lista");
          break;
        default:
          if (this.$route.name != "Home") this.$router.push("home");
          break;
      }
    },
  },
};
</script>

<style scoped>
.nav-bar {
  background: rgb(42, 99, 179);
}

.option {
  text-align: center;
  box-shadow: 1px 1px 3px rgba(0, 0, 0, 1),
    inset 1px 1px 1px rgba(255, 255, 255, 0);
}
</style>



// WEBPACK FOOTER //
// src/components/navbar/NavBar.vue